import { useRouteError } from "react-router-dom";

export function AppError(): JSX.Element {
    const error = useRouteError();
    const message = error instanceof Error ? error.message : String(error);
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
            <h1 className="text-2xl font-semibold">Something went wrong</h1>
            <p>If this keeps happening, please contact helpdesk@jtcgroup.com and include the details below.</p>
            <p className="text-sm text-neutral-500">{message}</p>
            <button className="rounded-lg bg-jtc-pink px-5 py-2.5 text-jtc-white" onClick={() => window.location.assign("/")}>
                Reload ChatJTC
            </button>
        </div>
    );
}
